import { component } from 'picoapp';

export default component((node, ctx) => {
  
  const init = () => {
    $(node).on('click', '.js-load-button', function(e) {
      e.preventDefault();
      const nextUrl = this.getAttribute('href');
      loadNextPage(nextUrl);
    });
  };

  const loadNextPage = (url) => {
    $
      .ajax({
        url,
        type: 'GET',
        beforeSend: () => {
          $('.js-load-button').remove();
        }
      })
      .done((data) => {
        $('.js-posts-container').append($(data).find('.js-posts-container').html());
      });
  };

  init();
});